import * as React from "react";
import {observer} from "mobx-react";

import "./layer-list-list.scss";

import {LayerListItem} from "./layer-list-item/layer-list-item";
import {LayerListConfiguration} from "../../../config/layer-list-configuration";
import {UiState} from "../../../ui-state";
import {SyntheticEvent} from "react";
import {AppState} from "../../../../components/app/app-mobx";
import {SidebarControlsConfiguration} from "../../../../config/sidebar-configuration";
import ListItem from "@arcgis/core/widgets/LayerList/ListItem";
import MapView from "@arcgis/core/views/MapView";
import SceneView from "@arcgis/core/views/SceneView";
import {MapState} from "../../../map-state";

export interface LayerListListProps {
    listItems: ListItem[];
    isRoot: boolean; // the root list
    level: number;
    onListItemClick: (event: SyntheticEvent, data: object, item: ListItem) => any;
    config: LayerListConfiguration;
    view: MapView | SceneView | undefined;
    uiStore: UiState;
    appStore: AppState;
    mapStore: MapState;
    controlsConfig: SidebarControlsConfiguration;
    small?: boolean;
}

@observer
export class LayerListList extends React.Component<LayerListListProps, any> {
    constructor(props: LayerListListProps) {
        super(props);
    }

    render(): JSX.Element | JSX.Element[] {
        const {listItems} = this.props;
        const {onListItemClick, config, controlsConfig, level, isRoot, small, appStore, mapStore, uiStore, view}
            = this.props;
        const showElement = (controlsConfig.layerList.startLevel <= level);
        const listElements = listItems.map((oi: ListItem, index: number) =>
            <LayerListItem key={oi.layer.id || "listitem-" + index}
                data={oi}
                subitems={oi.children}
                isRoot={isRoot}
                level={level}
                onClick={onListItemClick}
                mapStore={mapStore}
                metadata={config.metadata}
                config={config}
                small={small as boolean}
                uiStore={uiStore}
                view={view}
                controlsConfig={controlsConfig}
                appStore={appStore}/>
        );
        if (showElement) {
            return (
                <ul className={`layer-list ${isRoot ? "list-root" : "list-layer-root"}`}>
                    {listElements}
                </ul>
            );
        } else {
            return listElements;
        }

    }

    componentDidMount(): void {
    }

}
